module.exports = __webpack_public_path__ + "static/media/FFEP_230502.ecbe73ab.jpg";